import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getBprmForm, loadBprmForm } from '../../store/bprmForm';
import WorkflowElement from '../bprmForm/WorkflowElement';

const ReviewTask = (props) => {

    const [wfForm, setWfForm] = useState(null);
    const [wfTask, setWfTask] = useState(null);
    const [clientId, setClientId] = useState(null);
    const [appId, setAppId] = useState(null);
    const [pSize, setPSize] = useState(5);
    const [pIndex, setPIndex] = useState(1);

    const bprmFormSelector = useSelector(getBprmForm);

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        console.log("ReviewTask - location.state:", location.state);
        if (location?.state?.clientId) {
            const { clientId, appId, pSize, pIndex, wfTask } = location?.state;
            setClientId(clientId);
            setAppId(appId);
            setPSize(pSize);
            setPIndex(pIndex);
            if (wfTask?.formId > 0) {
                dispatch(loadBprmForm(wfTask.formId, clientId));
                setWfTask(wfTask);
            }
        }
    }, [location]);

    useEffect(() => {
        setWfForm(bprmFormSelector);
    }, [bprmFormSelector]);

    const handleNextTask = (data) => {
        navigate('/issues', { state: { clientId, appId, pSize, pIndex } }); // fallback route
    }

    return (
        <div>
           {wfForm && wfTask && <WorkflowElement wfForm={wfForm} wfTask={wfTask} clientId={clientId} handleNextTask={handleNextTask} />}
        </div>
    );
}

export default ReviewTask;